(() => {
  const MOBILE_MAX_WIDTH = 749;
  const DEFAULT_SCROLL_THRESHOLD = 100;

  const isMobile = () => window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`).matches;

  class MobileBottomNav {
    constructor() {
      this.bottomNav = document.querySelector('[data-mobile-bottom-nav]');
      this.stickyBar = document.querySelector('[data-mobile-product-sticky-bar]');
      this.cartBadge = document.querySelector('[data-mobile-cart-count]');
      this.stickyPrice = document.querySelector('[data-mobile-sticky-price]');
      this.stickyAddButton = document.querySelector('[data-mobile-sticky-add-to-cart]');
      this.scrollThreshold = Number(this.stickyBar?.dataset.scrollThreshold || DEFAULT_SCROLL_THRESHOLD);
      this.isProductPage = Boolean(this.stickyBar);

      if (!this.bottomNav && !this.stickyBar) return;

      document.body.classList.add('has-mobile-bottom-nav');
      this.bindEvents();
      this.syncStickyButtonState();
      this.updateBarsForScroll(window.scrollY || window.pageYOffset);
    }

    setBodyPadding(showBottomNav, showStickyBar) {
      document.body.classList.toggle('has-mobile-bottom-nav--visible', showBottomNav);
      document.body.classList.toggle('has-mobile-product-sticky-bar--visible', showStickyBar);
    }

    bindEvents() {
      window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
      window.addEventListener('resize', this.handleResize.bind(this));

      this.stickyAddButton?.addEventListener('click', this.handleStickyAddToCart.bind(this));

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          const count = event?.cartData?.item_count;
          if (typeof count === 'number') {
            this.updateCartCount(count);
            return;
          }

          this.syncCartCountFromHeader();
        });

        if (this.isProductPage) {
          subscribe(PUB_SUB_EVENTS.variantChange, () => {
            this.syncStickyPrice();
            this.syncStickyButtonState();
          });
        }
      }

      const productForm = document.querySelector('product-form');
      productForm?.addEventListener('change', () => {
        this.syncStickyButtonState();
      });

      if (this.stickyAddButton && productForm) {
        const observer = new MutationObserver(() => this.syncStickyButtonState());
        const submitButton = productForm.querySelector('.product-form__submit');
        if (submitButton) {
          observer.observe(submitButton, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled', 'class'],
            subtree: true,
            childList: true,
            characterData: true,
          });
        }
      }
    }

    syncCartCountFromHeader() {
      const headerCount = document.querySelector('#cart-icon-bubble [aria-hidden="true"]');
      if (!headerCount) return;

      const count = parseInt(headerCount.textContent, 10);
      if (!Number.isNaN(count)) {
        this.updateCartCount(count);
      }
    }

    handleResize() {
      if (!isMobile()) {
        this.bottomNav?.classList.remove('is-hidden');
        this.stickyBar?.classList.add('is-hidden');
        this.setBodyPadding(false, false);
        return;
      }

      this.updateBarsForScroll(window.scrollY || window.pageYOffset);
    }

    handleScroll() {
      if (!isMobile()) return;
      this.updateBarsForScroll(window.scrollY || window.pageYOffset);
    }

    updateBarsForScroll(scrollY) {
      if (!isMobile()) {
        this.setBodyPadding(false, false);
        return;
      }

      if (this.isProductPage) {
        const showStickyBar = scrollY >= this.scrollThreshold;
        this.stickyBar?.classList.toggle('is-hidden', !showStickyBar);
        this.bottomNav?.classList.add('is-hidden');
        this.setBodyPadding(false, showStickyBar);
        return;
      }

      this.bottomNav?.classList.remove('is-hidden');
      this.stickyBar?.classList.add('is-hidden');
      this.setBodyPadding(true, false);
    }

    handleStickyAddToCart() {
      const submitButton = document.querySelector('product-form .product-form__submit');
      if (!submitButton || submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      submitButton.click();
    }

    syncStickyPrice() {
      if (!this.stickyPrice) return;

      const priceContainer = document.querySelector('[id^="price-"]');
      if (!priceContainer) return;

      this.stickyPrice.innerHTML = priceContainer.innerHTML;
    }

    syncStickyButtonState() {
      if (!this.stickyAddButton) return;

      const submitButton = document.querySelector('product-form .product-form__submit');
      if (!submitButton) return;

      const submitLabel = submitButton.querySelector('span');
      const isDisabled = submitButton.disabled || submitButton.getAttribute('aria-disabled') === 'true';

      this.stickyAddButton.disabled = isDisabled;
      this.stickyAddButton.textContent = submitLabel?.textContent?.trim() || window.variantStrings?.addToCart || 'Add to Cart';
      this.stickyAddButton.classList.toggle('loading', submitButton.classList.contains('loading'));
    }

    updateCartCount(count) {
      if (!this.cartBadge) return;

      if (count > 0) {
        this.cartBadge.hidden = false;
        this.cartBadge.textContent = count < 100 ? String(count) : '99+';
      } else {
        this.cartBadge.hidden = true;
        this.cartBadge.textContent = '';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new MobileBottomNav());
  } else {
    new MobileBottomNav();
  }
})();
